export enum AuthType {
  REGISTER_OR_LOGIN_BY_CODE = "registerOrLoginByCode",
  REGISTER_OR_LOGIN = "registerOrLogin",
  REGISTER_OR_LOGIN_WITH_GOOGLE_IN_PROCESS = "registerOrLoginWithGoogle",
  LOGIN_BY_PASSWORD = "loginByPassword",
  REGISTRATION_FORM = "registrationForm",
}
